import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import metedata from "../metaData";
export let _workOrder;
let response;

export class SelectWorkOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workOrder: "",
      allWorkorders: [],
      type: ""
    };
    this.handleWorkorderChange = this.handleWorkorderChange.bind(this);
    this.handleGoClick = this.handleGoClick.bind(this);
    this.TypeChange = this.TypeChange.bind(this);
    this.clientClickAuto = this.clientClickAuto.bind(this);
  }
  componentDidMount() {
    let loginDetails = localStorage.getItem("loginDetails");
    if (loginDetails) {
      loginDetails = JSON.parse(loginDetails);
    }
    console.log(loginDetails.user.user_type, "user_typep");
    let user_type;
    if (window.user_type) {
      user_type = window.user_type;
    } else {
      if (loginDetails) {
        user_type = loginDetails.user.user_type;
      }
    }

    let workOrder;
    if (window.workOrder) {
      workOrder = window.workOrder;
    } else {
      workOrder = loginDetails.user.workOrder;
    }
    console.log(user_type, workOrder, "workOrder00k");

    let session = metedata[0].headers["x-zippr-sessiontoken"];
    console.log(session, "ddmcalled");
    if (!session) {
      console.log(window.sessionToken, "sessiontty");
      metedata[0].headers["x-zippr-sessiontoken"] = window.sessionToken;
    }
    console.log(workOrder, "workOrderlll");
    let workorderArr = [];
    if (workOrder) {
      console.log(workOrder.split(","), "workorderrkk");
      workorderArr = workOrder.split(",");
    }
    if (user_type == "admin") {
      let allWorkorders = [];
      axios
        .get(metedata[0].getWorkOrders.url, {
          headers: metedata[0].headers
        })
        .then(res => {
          console.log(res, "responsewr");
          let response = res.data.response.workOrderObjs;

          response.map(workOrderObj => {
            allWorkorders.push(workOrderObj.workOrder);
          });
          allWorkorders.map((ele, index) => {
            if (ele == "AP1") {
              allWorkorders.splice(index, 1);
              allWorkorders.unshift("AP1");
            }
          });
        })
        .then(() => {
          this.setState({ allWorkorders: allWorkorders });
          axios
            .get(metedata[0].workorderDetails.url, {
              params: { work_order: allWorkorders[0] },
              headers: metedata[0].headers
            })
            .then(res => {
              response = res.data.response.workOrderObj;
            });
          this.setState({
            workOrder: allWorkorders[0]
          });
        });
    } else if (workorderArr.length > 1) {
      axios
        .get(metedata[0].workorderDetails.url, {
          params: { work_order: workorderArr[0] },
          headers: metedata[0].headers
        })
        .then(res => {
          response = res.data.response.workOrderObj;
        });
      this.setState({
        workOrder: workorderArr[0]
      });
      this.setState({ allWorkorders: workorderArr });
    } else if (workorderArr.length == 1) {
      console.log(workOrder, "workOrderelseiff");

      axios
        .get(metedata[0].workorderDetails.url, {
          params: { work_order: workorderArr[0] },
          headers: metedata[0].headers
        })
        .then(res => {
          response = res.data.response.workOrderObj;
        });
      this.setState({
        workOrder: workorderArr[0]
      });
      this.setState({ allWorkorders: workorderArr });
      // this.clientClickAuto(workOrder);
    } else {
      this.setState({
        allWorkorders: []
      });
    }

    // if (user_type == "client" && workOrder) {
    //   this.clientClickAuto(workOrder);
    // } else {
    //   axios
    //     .get(metedata[0].getWorkOrders.url, {
    //       headers: metedata[0].headers
    //     })
    //     .then(res => {
    //       console.log(res, "responsewr");
    //       let response = res.data.response.workOrderObjs;
    //       let allWorkorders = [];

    //       response.map(workOrderObj => {
    //         allWorkorders.push(workOrderObj.workOrder);
    //       });
    //       allWorkorders.map((ele, index) => {
    //         if (ele == "AP1") {
    //           allWorkorders.splice(index, 1);
    //           allWorkorders.unshift("AP1");
    //         }
    //       });

    //       this.setState({ allWorkorders: allWorkorders });
    //     });

    //   axios
    //     .get(metedata[0].workorderDetails.url, {
    //       params: { work_order: "AP1" },
    //       headers: metedata[0].headers
    //     })
    //     .then(res => {
    //       response = res.data.response.workOrderObj;
    //     });
    //   this.setState({
    //     workOrder: "AP1"
    //   });
    // }
  }

  handleWorkorderChange(e) {
    axios
      .get(metedata[0].workorderDetails.url, {
        params: { work_order: e.target.value },
        headers: metedata[0].headers
      })
      .then(res => {
        response = res.data.response.workOrderObj;
      });
    this.setState({
      workOrder: e.target.value
    });

    //https://dev.zip.pr/ddn-dashboard/v2/workorder?work_order=AP
  }

  TypeChange(e) {
    if (e.target.value) {
      this.setState({
        type: e.target.value
      });
    }
  }

  handleGoClick(e) {
    _workOrder = response;
    localStorage.setItem("workOrderObj", JSON.stringify(response));

    let type;
    if (this.state.type) {
      type = this.state.type;
    } else {
      type = "creation";
    }
    localStorage.setItem("type", JSON.stringify(type));

    if (this.props.history) {
      this.props.history.push("/home");
    }
    window.location.reload();

    // async function f() {
    //     return localStorage.setItem("workOrderObj", JSON.stringify(response));
    //   }

    //   f().then(  window.location.reload());
  }

  clientClickAuto(workOrder) {
    axios
      .get(metedata[0].workorderDetails.url, {
        params: { work_order: workOrder },
        headers: metedata[0].headers
      })
      .then(res => {
        console.log(res.data.response.workOrderObj, "ooiiigg");
        response = res.data.response.workOrderObj;
      })
      .then(res => {
        this.handleGoClick();
      });
  }

  render() {
    _workOrder = response;
    return (
      <div>
        <div className="container-fluid">
          <div className="card">
            <div className="col-md-12" id="heading-timeline" style={{fontWeight: 'bold'}}>
              SELECT WORKORDER
            </div>
            <br />

            <div className="row select-workorder-row">
              <div className="col-md-2 workorder-text">
                <b>Type</b>
              </div>
              <div className="col-md-10">
                <select className="select-project" onChange={this.TypeChange}>
                  <option value="creation">Creation</option>
                  <option value="installation">Installation</option>
                  <option value="verification">Verification</option>
                </select>
              </div>
            </div>
            <br />

            <div className="row select-workorder-row">
              <div className="col-md-2 workorder-text">
                <b>WorkOrder</b>
              </div>
              <div className="col-md-10">
                <select
                  className="select-project"
                  onChange={this.handleWorkorderChange}
                >
                  {/* <option value="AP1">AP1</option> */}
                  {this.state.allWorkorders.map(workorder => {
                    return <option value={workorder}>{workorder}</option>;
                  })}
                  {/* <option value="AP">AP</option>
                                    <option value="AP1">AP1</option>
                                    <option value="ND">ND</option>
                                    <option value="MP">MP</option> */}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-10 go-button-container">
                <button
                  className="go-button"
                  onClick={this.handleGoClick}
                  disabled={this.state.workOrder.length ? "" : "disabled"}
                >
                  {" "}
                  <Link to="home" style={{ color: "white" }}>
                    {" "}
                    Go
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let { workOrder } = state;
  //   workOrder= workOrder
  return { workOrder: _workOrder };
}
const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectWorkOrder);
